import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { FaFilter } from "react-icons/fa";
import { AiFillAppstore } from "react-icons/ai";
import Add from "@mui/icons-material/Add";
import PatientLogo from "../../Images/ClinicSVG/newdoctor.svg";
import Loader from "../Loader/Loader";
import { Link } from "react-router-dom";
import Apiservice from "../../Services/Apiservice";

const ClinicTrainerList = () => {
  const [doctordetails, setdoctordetails] = useState([]);
  const savedtoken = localStorage.getItem("SavedToken");

  const [loading, setLoading] = useState(true);
  const clinciID = localStorage.getItem("ClinicIDForHomepage");
  const SubClinicIDForHomepage = localStorage.getItem("SubClinicIDForHomepage");
  // const is_clinic = localStorage.getItem("is_clinic");

  useEffect(() => {
    Apiservice
     
      .get(
        clinic == "true" ?
        `/user/trainer/clinic/${clinciID}/`
        :
        `/user/trainer/subclinic/${SubClinicIDForHomepage}/`
        , {
        headers: {
          Authorization: `Token ${savedtoken}`,
        },
      })

      .then((response) => {
        setdoctordetails(response.data);
        setLoading(false);
      })
      .catch((err) => {});
  }, []);
  if (!doctordetails) return null;

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const columns = [
    {
      field: "trainer_id",
      headerName: "ID",
      width: 90,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "trainer_firstName",
      headerName: "First name",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "trainer_lastName",
      headerName: "Last name",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "Qualifications",
      headerName: "Qualifications",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "trainer_age",
      headerName: "Age",
      //   type: "number",
      width: 110,
      headerClassName: "super-app-theme--header",
      //   align:"center"
    },
    {
      field: "trainer_gender",
      headerName: "Gender",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "trainer_mobile",
      headerName: "Mobile",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "trainer_email",
      headerName: "Email",
      width: 220,
      headerClassName: "super-app-theme--header",
    },
  ];

  const clinic = localStorage.getItem("is_clinic");

  return (
    <div>
      <div className="paient-list-top-main-flex-div">
        <div className="paient-list-top-main-width-div">
          <div
            className="paient-list-top-main-div"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="page-header-main-div">
              <p>Trainer List</p>
            </div>

            <div
              className="table-page-middle-nav-main-div"
              style={{ paddingBottom: "0px" }}
            >
              <div>
                {clinic == "true" ? (
                  <Link to="/clinicsidebar/trainerregistration">
                    <button className="add-btn-btn-tag">
                      <Add style={{ height: "20px", width: "20px" }} />
                      Add New Trainer
                    </button>
                  </Link>
                ) : (
                  <Link to="/subclinicsidebar/trainerregistration">
                    <button className="add-btn-btn-tag">
                      <Add style={{ height: "20px", width: "20px" }} />
                      Add New Trainer
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div style={{ padding: "15px" }}>
          <Box
            sx={{
              height: 600,
              width: "100%",
              "& .super-app-theme--header": {
                backgroundColor: "rgb(49, 163, 214)",
              },
            }}
          >
            <DataGrid
              rows={doctordetails}
              columns={columns}
              // pageSize={5}
              // rowsPerPageOptions={[5]}
              experimentalFeatures={{ newEditingApi: true }}
              getRowId={(row) => generateRandom()}
            />
          </Box>
        </div>
      )}
    </div>
  );
};

export default ClinicTrainerList;
